export const devisConstants = {
    CREATEDEVIS_REQUEST: 'CREATE_DEVIS_REQUEST',
    DEVIS_LOADING: 'DEVIS_LOADING',
    GETDEVIS_SUCCESS: 'GETDEVIS_SUCCESS',
    GETDEVIS_FAILURE: 'GETDEVIS_FAILURE',
}
